import PropTypes from "prop-types";
import { Colors } from "../../constants/colors";

export const PROPS = {
  size: PropTypes.oneOf([
    "xsmall",
    "small",
    "medium",
    "large",
    "xlarge",
    "xxlarge",
    "xxxlarge",
    "banner",
    "screenPlaceholder",
    "sizebarNavigation",
    "launchCardHeader",
    "default",
  ]),
  color: PropTypes.oneOf([
    "inherit",
    "primary",
    "secondary",
    ...Object.keys(Colors).map((x) => x.toLocaleLowerCase()),
  ]),
  className: PropTypes.string,
  component: PropTypes.any,
};

export const DEFAULTPROPS = {
  size: "medium",
  color: "inherit",
};
